import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { IWaybill } from '../interfaces';
import { WaybillMapper } from '../mappers';

export type IGetWaybillsRepoResponse = IRepoResponse<200, IWaybill[]> | IRepoResponse<400 | 500, string>;
export type IGetWaybillsRepoInput = { declarationId?: number | string; flightId?: string | number; partnerId?: string | number };

export type IGetWaybillsRepo = IRepo<[IGetWaybillsRepoInput], IGetWaybillsRepoResponse>;

export const GetWaybillsRepoType = Symbol.for('GetWaybillsRepo');

@bind(GetWaybillsRepoType)
export class GetWaybillsRepo implements IGetWaybillsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute({ declarationId, flightId, partnerId }) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/declaration/manifesto', { declaration_id: declarationId, flight_id: flightId, partner_id: partnerId }) });

      if (result.status === 200) {
        const data: IWaybill[] = result.data.map((waybill) => WaybillMapper.toDomain(waybill));

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
